import { all, call, put, take } from 'redux-saga/effects';

import { notifications, GET_ANNOTATIONS_FAIL } from 'PipeRouter';
import { GET_ANNOTATIONS, NORMALIZE_ALL } from './actions';
import { getBookmarks, getHighlightsAndMarkers } from 'Services/learnkit';


function* getAnnotations() {
  yield take(GET_ANNOTATIONS);

  try {
    const [ vsBookmarks, vsHighlightsAndMarkers ] = yield all([
      call(getBookmarks),
      call(getHighlightsAndMarkers)
    ]);

    const toNormalize = {
      vsBookmarks,
      vsHighlightsAndMarkers
    };

    yield put({ type: NORMALIZE_ALL, data: toNormalize });
  } catch (err) {
    debugger;
    yield put(notifications(GET_ANNOTATIONS_FAIL));
  }
}


export default getAnnotations;
